import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
    MDBAlert,
    MDBBtn,
    MDBIcon,
    MDBModalFooter,
    MDBSpinner,
} from "mdb-react-ui-kit";
import { useLocation, useNavigate } from "react-router";
import { editPhoneNumberDetails, getMisc, removeUser911Location } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../PopupLoader";
import AddNineOneOneLocation from "./Add911Location";
import PopupLoaderNew from "../PopupLoaderNew";

const Remove911Locations = forwardRef((props, ref) => {
    const [successMessage, setSuccessMessage] = useState("");
    const [nineooemergency, setNineOOEmergency] = useState([]);
    const [displayDropDown, setDisplayDropDown] = useState(0);
    const [emValue, setEmValue] = useState(0);
    const [emError, setEmError] = useState("");

    const location = useLocation();
    const navigate = useNavigate();
    const [Add911Location, setAdd911Location] = useState(false);
    const toggleShow25 = () => setAdd911Location(!Add911Location);
    const { t, i18n } = useTranslation();
    const [locationName, setlocationName] = useState("");
    const [rerender, setReRender] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const addLocationRef = useRef(null);
    // const [isloading, setIsloading] = useState(false);
    console.log("Remove911Location in 911 profile :::: " + JSON.stringify(props));

    function handleClick() {
        addLocationRef.current.click();
    }

    const delete911Location = async () => {
        console.log(`in delete911Location ::::::::::::::::: ${props}`);
        if (validateInputs()) {
            console.log("removeLocationId:::::::::" + props?.remove911LocationInfo);
            let siteid = JSON.parse(sessionStorage.getItem("admin_session"))?.siteid;

            let extraURL = "";
            if (displayDropDown === 2) {
                if (emValue && emValue !== 0) {
                    extraURL = `?transfer_nineoolocid=${emValue}`;
                }
            }
            props.setIsloading(true);
            let saverep = await removeUser911Location(siteid, props?.remove911LocationInfo?.nineoo_loc_id, extraURL);
            let saverepeMsg = await saverep.json();
            props.setIsloading(false);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                localStorage.setItem("s_message", saverepeMsg.message);
                props?.onClose();
                navigate("/LocLanding", { state: { tab: "location", tab1: "tab3" } });
                window.location.reload();
                // window.location.href = "/LocLanding";
            } else {
                if (saverepeMsg.message?.errors) {
                    console.log(saverepeMsg.message?.errors)
                    saverepeMsg.message.errors.forEach((err) => {
                        if (err.param_name.trim() == 'transfer_nineoolocid') {
                            setEmValue(err.message);
                        }
                    });
                } else {
                    setErrorMessage(saverepeMsg.message);
                }
            }
        }
    }
    const validateInputs = () => {
        console.log(`in validateInputs ::::::::::::::::: `)
        if (displayDropDown === 2 && parseInt(emValue) === 0) {
            setEmError("Please select an emergency 911 location.");
            return false;
        }
        return true;
    }
    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    useEffect(() => {
        if ((props?.remove911LocationInfo && props?.remove911LocationInfo.nineoo_loc_id && props?.remove911LocationInfo.nineoo_loc_id != "" && !props.nineoolocation) || rerender) {
            if (props.nineoolocation && props.nineoolocation.length > 0) {
                get911LocationList();

            } else {
                getDelete911LocationDependency();
            }
            setReRender(false);
        }


    }, [props?.remove911LocationInfo, rerender]);

    useEffect(() => {
        if (props.nineoolocation && props.nineoolocation.length > 0) {
            setNineOOEmergency(props.nineoolocation);
            setDisplayDropDown(2);
        }

    }, [props.nineoolocation])

    useEffect(() => {
        if (errorMessage) {
            setTimeout(() => {
                setErrorMessage(""); // Clear the error message in the parent component
            }, 5000);
        }
    }, [errorMessage]);

    async function get911LocationList() {
        props.setIsloading(true);
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["nineoo_loc_list"] }
        );
        console.log(response);
        props.setIsloading(false);

        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        } else {
            const tdata = await response.json();
            if (!tdata) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            console.log("Response Data for delete 911 list:", JSON.stringify(tdata));
            const emgLocArr = tdata?.misc?.nineoo_loc_list ?? [];
            if (emgLocArr.length > 0) {
                if (locationName && locationName.trim() != "") {
                    const jsonObj = emgLocArr.find(item => item.loc_name.trim() === locationName.trim());
                    setEmValue(jsonObj?.nineoo_loc_id ?? 0);
                }
            }
            setNineOOEmergency(emgLocArr);
            setDisplayDropDown(2);
        }
    }

    async function getDelete911LocationDependency() {
        props.setIsloading(true);
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["nineoo_loc_delete"], nineoo_loc_id: props?.remove911LocationInfo.nineoo_loc_id }
        );
        console.log(response);
        props.setIsloading(false);

        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        } else {
            const tdata = await response.json();
            if (!tdata) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            console.log("Response Data:", JSON.stringify(tdata));
            const emgLoc = tdata?.misc?.nineoo_loc_delete?.emergency_assoc ?? [];
            if (emgLoc.length > 0) {
                const emgLocArr = emgLoc.filter(loc => loc.nineoo_loc_id !== props.remove911LocationInfo.nineoo_loc_id);
                if (emgLocArr.length > 0) {
                    if (locationName && locationName.trim() != "") {
                        const jsonObj = emgLocArr.find(item => item.loc_name.trim() === locationName.trim());
                        setEmValue(jsonObj?.nineoo_loc_id ?? 0);
                    } else {
                        const jsonObj = emgLocArr.find(item => item.default_loc === true);
                        setEmValue(jsonObj?.nineoo_loc_id ?? 0);
                    }
                }
                setNineOOEmergency(emgLocArr);
            }
            setDisplayDropDown(tdata?.misc?.nineoo_loc_delete?.display_flag ?? 1);
        }


    }

    async function allowToChange(e) {
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let update = { ...props.remove911LocationInfo, save_flag: true }
        console.log(update);
        props.setIsloading(true);
        let saverep = await editPhoneNumberDetails(update, `?transfer_nineoolocid=${emValue}`);
        console.log(`reponse of phone edit :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(
            "response of modified data :::" + JSON.stringify(saverepeMsg)
        );
        setTimeout(() => {
            props.setIsloading(false);
        }, 1000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            props.setRerender(true);
            props.setSuccessMessage(saverepeMsg.message);
        } else {
            props.setRerender(true);
            props.onClose();
        }

    }

    return (
        <React.Fragment>
            <>
                <div>
                    {displayDropDown == 1 && (
                        // <div className="py-2 pb-4">
                        //     {t("Remove911Locationtxt")}
                        // </div>
                        <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                            <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                            <span>{t("Remove911Locationtxt")}</span>
                        </div>

                    )
                    }

                    {displayDropDown == 2 && (
                        <>
                            <div>
                                <span className="phrecording">
                                    {t("Rem911Locationtxt")}
                                </span>
                            </div>
                            <div className="tel-numbers mt-1">
                                <strong>{t("select911loc")}</strong>
                            </div>
                            <span className="phrecording">
                                {t("Search911enloc")}
                            </span>
                            <div className="form my-3 d-inline-flex w-100 justify-content-between">
                                <div className="w-50">

                                    <select
                                        className="form-select form-control w-100"
                                        name="San Jose"
                                        value={emValue}
                                        onChange={(e) => setEmValue(e.target.value)}
                                    >
                                        <option value={0}>--Select Location--</option>
                                        {nineooemergency && nineooemergency.map((em) => (
                                            <option value={em.nineoo_loc_id}>{em.loc_name}</option>
                                        ))}
                                    </select>
                                    {emError && <div style={{ color: 'red' }}>{emError}</div>}
                                </div>
                                <MDBBtn onClick={toggleShow25}><MDBIcon fas icon="plus" size="sm" /> {t("add911onlyloc")}</MDBBtn>
                            </div>
                        </>
                    )
                    }

                    {/* <MDBModalFooter className="mt-1">
                        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                            {t("close")}
                        </MDBBtn>
                        <MDBBtn onClick={() => delete911Location(props)}>{t("remove")}</MDBBtn>
                    </MDBModalFooter> */}
                    <div style={{ display: "none" }}>
                        <button ref={ref} onClick={(e) => {
                            e.preventDefault();
                            if (props.nineoolocation && props.nineoolocation.length > 0) {
                                allowToChange();
                            } else { delete911Location(props) }
                        }}>
                            {t("ok")}</button>
                    </div>

                </div>
                {Add911Location && (
                    <PopupLoaderNew
                        title={t("Add911Loc")}
                        content={
                            <AddNineOneOneLocation
                                setAcdActive={null}
                                setSuccessMessage={setSuccessMessage}
                                setReRender={setReRender}
                                removeFlag={true}
                                setlocationName={setlocationName}
                                onClose={toggleShow25}
                                ref={addLocationRef}
                                setIsloading={props.setIsloading}

                            />}
                        onShow={setAdd911Location}
                        onClose={toggleShow25}
                        onSave={handleClick}
                        isloading={props.isloading}
                        flag={1}
                    />
                )}
                {successMessage && (
                    <MDBAlert
                        show
                        color="success"
                        autohide
                        position="bottom-right"
                        delay={10000}
                    >
                        <i className="fas fa-check-circle me-3"></i>
                        <span className="alert-msg">{successMessage}</span>
                    </MDBAlert>
                )
                }
                {errorMessage && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={10000}
                    >
                        <i className="fas fa-times-circle me-3"></i>
                        <span className="alert-msg">{errorMessage}</span>
                    </MDBAlert>
                )}
                {/* {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )} */}
            </>

        </React.Fragment >
    );
});
export default Remove911Locations;

